import React from "react";
import { motion } from "framer-motion";

export const Kicker = ({ children, className = "" }) => (
  <div className={`inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.18em] text-amber ${className}`}>
    <span className="w-6 h-px bg-amber/60" />
    {children}
  </div>
);

export const Section = ({ id, testId, className = "", children }) => (
  <section id={id} data-testid={testId} className={`relative py-20 md:py-28 ${className}`}>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">{children}</div>
  </section>
);

export const SectionHead = ({ kicker, title, body, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.5 }}
    className={`max-w-2xl ${className}`}
  >
    <Kicker>{kicker}</Kicker>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink mt-4 leading-[1.1]">
      {title}
    </h2>
    {body && <p className="mt-5 text-base md:text-lg text-ink-muted leading-relaxed">{body}</p>}
  </motion.div>
);

export const Chips = ({ options, value, onChange, prefix, counts }) => (
  <div className="flex flex-wrap gap-2" role="tablist">
    {options.map(([key, label]) => (
      <button
        key={key}
        type="button"
        role="tab"
        aria-selected={value === key}
        data-testid={`${prefix}-${key}`}
        onClick={() => onChange(key)}
        className={`rounded-full border px-4 py-2 text-sm font-bold transition-[background-color,color,border-color,transform] duration-200 active:scale-95 ${
          value === key
            ? "bg-moss border-moss text-parchment"
            : "bg-parchment/70 border-line text-ink hover:border-moss hover:text-moss"
        }`}
      >
        {label}
        {counts && <span className="ml-1.5 opacity-60 tabular-nums">{counts[key]}</span>}
      </button>
    ))}
  </div>
);

export const RarityDot = ({ color, className = "" }) => (
  <span className={`inline-block w-2.5 h-2.5 rounded-full ring-2 ring-parchment ${className}`} style={{ background: color }} />
);
